import { HttpHeaders, HttpParams } from '@angular/common/http';

export class HttpOptions {
    headers?: HttpHeaders;
    observe: 'body';
    responseType: 'json';
    params?: HttpParams;
}
